import type { ReactNode } from 'react'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgDragDropUrl from '@/assets/misc/img_drag-drop.svg'
import DragAndUploadIllustration from '@/components/SpotIllustration/DragAndUploadIllustration'

export interface OCRScopeJobUnselectedProps {
  children?: ReactNode
}

export function OCRScopeJobUnselected({
  children,
}: OCRScopeJobUnselectedProps) {
  return (
    <EmptyState size="sm">
      <EmptyStateIllustration
        src={imgDragDropUrl}
        illustration={byDesign(undefined, DragAndUploadIllustration)}
      />
      <EmptyStateTitle>Drag and drop to scope new jobs</EmptyStateTitle>
      <EmptyStateDescription>
        Upload one or more files here. Acceptable file types include: BMP, JPEG,
        JPG, PDF, PNG, TIF, TIFF, WEBP
      </EmptyStateDescription>
      {children && <EmptyStateActions>{children}</EmptyStateActions>}
    </EmptyState>
  )
}
